import React from "react";

const GameListContext = React.createContext();

export default GameListContext;